export default "__VITE_ASSET__b06bfe4e__"